/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router';
import PropTypes, { bool } from 'prop-types';

import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import ModalWrapper from '../ModalWrapper/ModalWrapper';
import ModalContent from '../ModalWrapper/Partials/ModalContent';

import BrandLogo from '../BrandLogo';
import SecureCheckout from './Partials/SecureCheckout';
import Breadcrumb from './Partials/Breadcrumb/Breadcrumb';
import CheckoutMobileHeader from './CheckoutMobileHeaders';
import { getCurrentBrandId } from '../../../../../state/ducks/App/ducks/Brand/Brand-Selectors';
import DesktopMobile from '../../../../helpers/DesktopMobile/DesktopMobile';
import { getPresentationFamily } from '../../../../../state/ducks/App/ducks/Config/Config-Selectors';
import { getLastAddedOrderItemDetails } from '../../../../../state/ducks/AddToCart/AddToCart-Selectors';
import { getOrderId } from '../../../../../state/ducks/Member/ducks/Common/Common-Selectors';
import { getPlaceOrderStatus, getRecipientForm } from '../../../../../state/ducks/Common/Common-Selectors';
import CUSTOM_BREAKPOINTS from '../../../../helpers/customBreakpoints';
import { getActiveABTests, getCheckoutFeatureFlag } from '../../../../../state/ducks/Checkout/ducks/App/App-Selectors';
import CheckoutBanner from '../CheckoutHeaderFood/Partials/CheckoutBanner/CheckoutBanner';
import { getSSRDeviceType } from '../../../../../state/ducks/App/App-Selectors';

const styles = (theme) => ({
    checkoutHeader: {
        margin: '0',
        padding: '0',
        borderBottom: `2px solid ${theme.palette.disableButton}`,
        [theme.breakpoints?.down(768)]: {
            borderBottom: 'none',
        },
    },
    root: {
        display: 'flex',
        alignItems: 'center',
        maxWidth: '1400px',
        padding: '0',
        backgroundColor: theme.palette.headerColor,
        marginBotton: '30px',
        justifyContent: 'space-between',
        margin: '0 auto',
        [theme.breakpoints.down('md')]: {
            marginTop: '0',
        },
        [theme.breakpoints.down(960)]: {
            backgroundColor: theme.palette.mobileMenuBG?.checkoutAddonBackground || theme.palette.cms?.mobileBgHeader || theme.palette.headerColor,
            marginBottom: '10px',
            boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.15)',
        },
    },
    brandLogo: {
        justifyContent: 'flex-start',
        [theme.breakpoints.down('md')]: {
            margin: ' 0 auto 0 0',
            width: '50%',
        },
    },
    navProgress: {
        display: 'flex',
        justifyContent: 'center',
        height: 'auto',
        margin: '0',
        '& h4': {
            textAlign: 'center',
        },
        /* commenting out for now, breadcurm is getting hidden for resolution below 820px
        '@media (max-width: 820px)': {
            display: 'none',
        },
        */
    },
    secureCheckout: {
        justifyContent: 'flex-end',
        width: 'auto',
        [theme.breakpoints.down('md')]: {
            width: '25%',
            justifyContent: 'right',
            display: 'flex',
        },
        [theme.breakpoints.down(960)]: {
            justifyContent: 'left',
        },
    },
    logoBrandBtn: {
        '&#btn-logo-brand': {
            backgroundColor: 'transparent',
            fontSize: '14px',
            width: '100%',
            fontWeight: 'bold',
            margin: '0',
            padding: '9px 8px',
            display: 'block',
            '&:hover, &:focus, &:active': {
                backgroundColor: 'transparent',
            },
            '& span': {
                textAlign: 'left',
                display: 'block',
                height: '46px',
            },
            [theme.breakpoints.down('md')]: {
                padding: '0',
                '& span': {
                    display: 'block',
                    marginLeft: '10px',
                },
            },
            [theme.breakpoints.down(960)]: {
                '& span': {
                    display: 'flex',
                    marginLeft: 'auto',
                },
            },
        },
    },
    mobileHeaderBlock: {
        color: theme.palette.white,
        display: 'flex',
        height: '54px',
        background: theme.palette.cms?.checkoutHeaderBg || theme.palette.checkoutHeaderBg,
        alignItems: 'center',
        justifyContent: 'space-between',
        [theme.breakpoints.down(960)]: {
            background: theme.palette.mobileMenuBG?.checkoutAddonBackground || theme.palette.cms?.mobileBgHeader || theme.palette.mobileMenuBG?.main || theme.palette.cms?.checkoutHeaderBg || theme.palette.checkoutHeaderBg,
        },
    },
    rootCheckoutHeader: {
        backgroundColor: '#F4F4F4',
    },
});

class CheckoutHeader extends Component {
    constructor(props) {
        super(props);
        const { orderId, deliveryFormFields, placeOrderStatus } = this.props;
        this.state = {
            isOpen: false,
            tabs: [
                {
                    label: 'Delivery',
                    filledStatus: false,
                    disabled: false,
                    linkUrl: `/checkout/shipping/${orderId}`,
                },
                {
                    label: 'Payment',
                    filledStatus: deliveryFormFields?.isFormValid,
                    disabled: true,
                    linkUrl: `/checkout/payment/${orderId}`,
                },
                {
                    label: 'Review',
                    filledStatus: placeOrderStatus,
                    disabled: true,
                    linkUrl: `/checkout/review-order/${orderId}`,
                },
            ],
            activeTab: 0,
        };

        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }

    componentDidMount() {
        const { currentTab } = this.props;
        const { activeTab } = this.state;
        if (activeTab !== currentTab) {
            this.setActiveTab(currentTab);
        }
    }

    setActiveTab(activeTab) {
        const { deliveryFormFields, placeOrderStatus } = this.props;
        const { tabs } = this.state;
        const updateTabs = [];

        tabs.forEach((element, index) => {
            updateTabs[index] = element;

            if (updateTabs[index].label === 'Delivery') {
                updateTabs[index].filledStatus = deliveryFormFields?.isFormValid;
                updateTabs[index].disabled = !deliveryFormFields?.isFormValid;
            }
            if (updateTabs[index].label === 'Payment') {
                updateTabs[index].filledStatus = placeOrderStatus;
                updateTabs[index].disabled = !placeOrderStatus;
            }
            if (updateTabs[index].label === 'Review') {
                updateTabs[index].filledStatus = placeOrderStatus;
                updateTabs[index].disabled = !placeOrderStatus;
            }
        });
        this.setState({ tabs: updateTabs, activeTab });
    }

    openModal() {
        this.setState({ isOpen: true });
    }

    closeModal() {
        this.setState({ isOpen: false });
    }

    isAddOnWrapUp() {
        const { location: { pathname } } = this.props;
        if (pathname === '/wrap-up' || pathname === '/add-ons') {
            return true;
        }
        return false;
    }

    isNonCheckoutPage() {
        const { location: { pathname } } = this.props;
        if (pathname
            && (pathname === '/wrap-up' || pathname === '/add-ons' || pathname.includes('/checkout/cart') || pathname.includes('/checkout/order-confirmation'))) {
            return true;
        }

        return false;
    }

    render() {
        const {
            classes, currentTab, placeOrderStatus, brand, lastAddedOrderItem,
            ffWhichCheckoutVariation, activeABTests, ssrDeviceType, presentationFamily, wrapupAddonRedesign,
        } = this.props;
        const { isOpen } = this.state;
        const modalContent = <ModalContent closeModal={this.closeModal} />;

        let titleAddons = '';
        if (lastAddedOrderItem?.product && !wrapupAddonRedesign) {
            titleAddons = 'Make Your Gift Extra Special';
            if (
                lastAddedOrderItem.product.sympathyValue === '1'
                || lastAddedOrderItem.product.sympathyValue === '2'
            ) {
                titleAddons = 'Add To Your Order';
            }
        }
        if (typeof window !== 'undefined' && ssrDeviceType.toLowerCase() === 'mobile' && presentationFamily === 'flower') {
            document.querySelector('#root').setAttribute('style', 'padding-top: 0px;');
        }

        return (
            <>
                <div className={classes.checkoutHeader}>
                    <DesktopMobile
                        breakpoint={CUSTOM_BREAKPOINTS.checkout}
                        mobile={() => (
                            <CheckoutMobileHeader
                                modalContent={modalContent}
                                isOpen={isOpen}
                                onCloseModal={this.closeModal}
                                btnClose={false}
                                classes={classes}
                                isAddOnWrapUp={this.isNonCheckoutPage()}
                                onClick={this.openModal}
                                currentTab={currentTab}
                                isPlaceOrder={placeOrderStatus}
                                withLink
                                brand={brand}
                                isUniversal={['enterprise', 'enterprise2'].includes(ffWhichCheckoutVariation) || activeABTests?.checkout === 'universal'}
                            />
                        )}
                        desktop={() => (
                            <Grid
                                container
                                title="Secure Checkout"
                                className={classes.root}
                            >
                                <Grid item xs={3} className={classes.brandLogo}>
                                    <Button
                                        id="btn-logo-brand"
                                        data-test="btn-logo-brand"
                                        name="logoBrandButton"
                                        className={classes.logoBrandBtn}
                                        onClick={this.openModal}
                                        disableRipple
                                    >
                                        <BrandLogo withLink brand={brand} />
                                    </Button>
                                </Grid>
                                <Grid item xs={6} className={classes.navProgress}>
                                    {this.isAddOnWrapUp()
                                        ? (
                                            <h4>{titleAddons}</h4>
                                        ) : (
                                            <>
                                                {
                                                    currentTab
                                                && currentTab !== 'cart'
                                                && currentTab !== 'confirmation'
                                                        ? <Breadcrumb active={currentTab} isPlaceOrder={placeOrderStatus} />
                                                        : null
                                                }
                                            </>
                                        )}
                                </Grid>
                                <Grid item xs={3} className={classes.secureCheckout}>
                                    <SecureCheckout isUniversal={(['enterprise', 'enterprise2'].includes(ffWhichCheckoutVariation) || activeABTests?.checkout === 'universal')} />
                                </Grid>
                                <ModalWrapper
                                    modalTitle="LEAVE CHECKOUT"
                                    modalContent={modalContent}
                                    isOpen={isOpen}
                                    onCloseModal={this.closeModal}
                                    btnClose={false}
                                />
                            </Grid>
                        )}
                    />
                </div>
                <DesktopMobile
                    desktop={() => (
                        (['enterprise', 'enterprise2'].includes(ffWhichCheckoutVariation) || activeABTests?.checkout === 'universal')
                        && !['cart', 'confirmation'].includes(currentTab)
                            ? <Grid container className={classes.rootCheckoutHeader}><CheckoutBanner isUniversal /></Grid>
                            : null
                    )}
                    mobile={null}
                    breakpoint={CUSTOM_BREAKPOINTS.checkout}
                />
            </>
        );
    }
}

const mapStateToProps = (state) => {
    if (!state?.checkout) {
        return ({
            orderId: '',
            deliveryFormFields: {},
            placeOrderStatus: false,
            brand: {},
            presentationFamily: '',
            lastAddedOrderItem: {},
            ffWhichCheckoutVariation: '',
            activeABTests: {},
        });
    }

    return ({
        orderId: getOrderId(state),
        deliveryFormFields: getRecipientForm(state),
        placeOrderStatus: getPlaceOrderStatus(state),
        brand: getCurrentBrandId(state),
        presentationFamily: getPresentationFamily(state),
        lastAddedOrderItem: getLastAddedOrderItemDetails(state),
        ffWhichCheckoutVariation: getCheckoutFeatureFlag('which-checkout-variation')(state) || '',
        activeABTests: getActiveABTests(state),
        ssrDeviceType: getSSRDeviceType(state),
    });
};

CheckoutHeader.propTypes = {
    placeOrderStatus: PropTypes.bool.isRequired,
    deliveryFormFields: PropTypes.object.isRequired,
    orderId: PropTypes.string.isRequired,
    classes: PropTypes.object.isRequired,
    currentTab: PropTypes.string,
    location: PropTypes.object.isRequired,
    brand: PropTypes.string.isRequired,
    lastAddedOrderItem: PropTypes.shape({
        product: PropTypes.shape({
            sympathyValue: PropTypes.string,
        }),
    }).isRequired,
    ffWhichCheckoutVariation: PropTypes.string,
    activeABTests: PropTypes.shape({
        checkout: PropTypes.string,
    }).isRequired,
    ssrDeviceType: PropTypes.string.isRequired,
    presentationFamily: PropTypes.string.isRequired,
    wrapupAddonRedesign: bool,
};

CheckoutHeader.defaultProps = {
    currentTab: null,
    ffWhichCheckoutVariation: 'flower',
    wrapupAddonRedesign: false,
};

export default compose(
    connect(mapStateToProps, null),
    withStyles(styles),
    withRouter,
)(CheckoutHeader);
